import React from 'react'
import PropTypes from 'prop-types'
import { Box, Button, Typography, withStyles } from '@material-ui/core'
import clsx from 'clsx'
// import axios from 'axios'

// styles
import { styles } from '../styles'

// components
import DataFilters from '../DataFilters'
import Report from './Report'
import { downloadReportImage } from '../UtilityActions'
import { hasColumn } from '../../../../helpers'

class OrganizationStructure extends React.Component {

	state = {
		showGraphs: false,
		reportData: null,
		fieldFilters: {
			'salary_p50': true,
			'salary_p75': true,
			'ttc_p50': false,
			'ttc_p75': true,
			'atc_p50': true,
			'atc_p75': true,
			'unvested_stock_options_p50': true,
			'unvested_stock_options_p75': true,
		},
		categoryFilters: {
			'executive': true,
			'management': true,
			'professional': true,
			'support': true
		},
		downloadErrTxt: '',
		processing: false,
	}

	dataFilters = {
		'department': [],
		'country': [],
		'function': [],
		'manager': []
	}

	componentDidMount() {
		this.whichFieldFiltersExist()
	}

	whichFieldFiltersExist = () => {
		let newFieldFilters = { ...this.state.fieldFilters }
		Object.keys(newFieldFilters).forEach(field => {
			if (hasColumn(this.props.availableColumns, this.tableColumnMapping(field))) {
				newFieldFilters[field] = true
			} else {
				newFieldFilters[field] = false
			}
		})
		this.setState({ fieldFilters: newFieldFilters })
	}

	tableColumnMapping = (value) => {
		if (value === 'salary_p50') {
			return 'comp_salary_p50'
		} else if (value === 'salary_p75') {
			return 'comp_salary_p75'
		} else if (value === 'ttc_p50') {
			return 'comp_ttc_p50'
		} else if (value === 'ttc_p75') {
			return 'comp_ttc_p75'
		} else if (value === 'atc_p50') {
			return 'comp_atc_p50'
		} else if (value === 'atc_p75') {
			return 'comp_atc_p75'
		} else if (value === 'unvested_stock_options_p50') {
			return 'comp_unvested_stock_options_p50'
		} else if (value === 'unvested_stock_options_p75') {
			return 'comp_unvested_stock_options_p75'
		}
	}

	getReportAPIPayload = (download = false) => {
		return {
			'dataFilters': this.dataFilters,
			'fieldFilters': this.state.fieldFilters,
			'categoryFilters': this.state.categoryFilters,
			'download': download
		}
	}

	// downloadReport = () => {
	// 	this.setState({ processing: true })
	// 	axios.post(`/api/report`, this.getReportAPIPayload(true))
	// 		.then((response) => {
	// 			this.setState({ processing: false })
	// 			window.open(response.data.data, "_blank")
	// 		})
	// 		.catch((error) => {
	// 			this.setState({ processing: false })
	// 			this.setState({ downloadErrTxt: 'Sorry, we are unable to process your request' })
	// 		})
	// }

	downloadOrganisationalReportImage = () => {
		downloadReportImage('organisation-compensation-report', 'organisation-compensation-report')
	}

	onApply = () => {
		this.props.onApply('OrganisationCompensation')
	}

	render() {
		const { classes } = this.props
		return (
			<>
				<Typography className={classes.typo} variant="h3" size="sm">
					Filters
				</Typography>

				<DataFilters
					fetchedFilterData={this.props.fetchedFilterData}
					filtersData={this.props.filtersData}
					componentName={this.props.componentName}
					reportFilters={this.props.reportFilters}
					onDataFilterSelect={this.props.onDataFilterSelect}
					onApply={this.onApply}
					resetFilter={this.props.resetFilter}
					reportFiltersType={this.props.reportFiltersType}
					reportDataChanged={this.props.reportDataChanged}
				/>
				<Box mt={3}></Box>
				<div className={classes.downloadBtnSection}>
					{this.state.downloadErrTxt ? <Typography variant='warning'>{this.state.downloadErrTxt}</Typography> : null}
					{this.state.processing ? 'Processing...' : null}
					{/* <Button
						variant="contained"
						color="primary"
						className={clsx(classes.button)}
						onClick={this.downloadReport}
					>
						Download (xlsx)
					</Button> */}
					<Button
						variant="contained"
						color="primary"
						className={clsx(classes.button)}
						onClick={() => this.downloadOrganisationalReportImage()}
					>
						Download (PNG)
					</Button>
				</div>
				{this.props.reportData === null ?
					<h5> Loading...</h5>
					:
					<Report
						reportData={this.props.reportData}
						fieldFilters={this.state.fieldFilters}
						categoryFilters={this.state.categoryFilters}
						jobGrades={this.props.masterData.jobGrades}
					/>
				}
			</>
		)
	}

}

OrganizationStructure.propTypes = {
	masterData: PropTypes.object.isRequired,
}

export default withStyles(styles)(OrganizationStructure)
